import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { Pane } from '@wds/internal-components';
import { KEYS } from '@wds/helpers';

const ModalBody = forwardRef(
  ({ className, children, handleClick, id, padding, ...rest }, ref) => {
    const handleKeyDown = (e) => {
      if (e.key === KEYS.ESC) {
        handleClick();
        e.preventDefault();
      }
    };

    return (
      // eslint-disable-next-line jsx-a11y/no-static-element-interactions
      <section
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex="0"
        ref={ref}
        id={id}
        className={className}
        onKeyDown={handleKeyDown}
        {...safeRest(rest)}
      >
        <Pane padding={padding} transparent>
          {children}
        </Pane>
      </section>
    );
  }
);

ModalBody.displayName = 'ModalBody';

ModalBody.propTypes = {
  /**
   * Modal Body content
   */
  children: PropTypes.node.isRequired,
  /**
   * Custom className
   */
  className: PropTypes.string,
  /**
   * On click event handler
   * function (event: object) => void
   */
  handleClick: PropTypes.func,
  /**
   * Modal ID
   */
  id: PropTypes.string,
  /**
   * If true, padding will be applied around Modal body
   */
  padding: PropTypes.bool,
};

ModalBody.defaultProps = {
  className: undefined,
  handleClick: undefined,
  id: undefined,
  padding: true,
};

export default ModalBody;
